<div
  class="hx-table-outer"
  [attr.data-header-variant]="headerVariant()"
  [attr.data-hover-variant]="hoverVariant()"
  [attr.data-row-height]="rowHeight()"
  [attr.data-row-variant]="rowVariant()"
  [class.hx-table--disabled]="disabled()"
  [class.hx-table--footer-fixed]="footerFixed()"
  [class.hx-table--header-frozen]="freezeHeader()"
  [class.hx-table--scrollable]="scrollMaxHeight() !== null"
  [style.height]="!freezeHeader() && footerFixed() && scrollMaxHeight() ? scrollMaxHeight() : null">
  <!-- Unified Scroll Container for Header and Body -->
  <div #scrollContainer class="hx-table-scroll-container">
    <!-- Header with its own wrapper -->
    <div
      class="hx-table-wrapper"
      [style.grid-template-columns]="gridTemplateColumns()"
      [style.max-height]="scrollMaxHeight()">
      <div #headerContainer class="hx-table-header" [class.hx-table-header-no-data]="!hasContent()">
        <ng-content select="hx-table-header" />
      </div>

      <!-- Body Container - vertical scroll only -->
      <div
        #bodyContainer
        class="hx-table-body"
        [attr.aria-label]="ariaLabel()"
        [attr.role]="'table'"
        [class]="cssClass()"
        [class.hx-table-body--hover-enabled]="enableRowHover()"
        [style.--hx-table-row-hover]="hoverColor() || 'var(--hx-table-row-hover)'">
        <ng-content select="hx-table-section" />

        <!-- Rows that are not inside a section -->
        <ng-content select="hx-table-row, hx-expandable-row" />

        @if (!hasContent()) {
          <div class="hx-table-no-data">
            {{ noDataMessage() }}
          </div>
        }
      </div>
    </div>
  </div>

  @if (hasFooter()) {
    <div #footerContainer class="hx-table-footer-container">
      <ng-content select="hx-table-footer" />
    </div>
  }
</div>
